import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Collapse,
  Grid,
  IconButton,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import {
  useGetAllByPolicyNumberQuery,
  useGetCustomerQuery,
  useGetProductBrandQuery,
  useGetProductQuery,
  useDeletePolicyMutation,
  useGetCustomerRelationQuery,
  useDeletePolicyFristIndexMutation,
  useGetAllByCoverageHistoryQuery,
  useGetUserInfoOnyQuery,
  useGetAllCategoryNameQuery,
} from "../../../Api/attoDeskApi";
import {
  ICustomer,
  ICustomerRelative,
  ICustomerRelative2,
  IPolicy,
  IPolicyHistoryRecords,
  IProductBrand,
  IProductPopUP,
  IUserAdmin,
  policyAllPrintTermsArray,
  policyTermsArray,
  ICategory,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import dayjs from "dayjs";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import NewTermsConditionReport from "../Component/NewTermsConditionReport";
import NewSummaryReport from "../Component/NewSummaryReport";
import NewOfficeUse from "../Component/NewOfficeUse";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { formatPhoneNumberForDisplaySpace } from "../../../Components/Validation/validationUtils";
import { PolicyCollectionType } from "../../../Core/Enum/enum";
import AvatarImg from "../../../Images/avatar.png";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { formatNumber } from "../../../Components/formatNumber/formatNumber";
import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";
import { GrStatusGood } from "react-icons/gr";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { IoPricetagsOutline } from "react-icons/io5";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

enum Section {
  Policy = "Policy",
  Info = "Info",
  Email = "Email",
  Note = "Note",
  History = "History",
  Todo = "Todo",
  Meeting = "Meeting",
}

function getPolicyCollectionType(policyPremiumFrequency: string) {
  switch (policyPremiumFrequency) {
    case PolicyCollectionType.OneTime:
      return "One Time";
    case PolicyCollectionType.Monthly:
      return "Monthly";
    case PolicyCollectionType.EveryTwoMonths:
      return "Every Two Months";
    case PolicyCollectionType.EveryThreeMonths:
      return "Every Three Months";
    case PolicyCollectionType.Quarterly:
      return "Quarterly";
    case PolicyCollectionType.SemiAnnually:
      return "Semi-Annually";
    case PolicyCollectionType.Annually:
      return "Annually";
    case PolicyCollectionType.Custom:
      return "Custom";
    default:
      return "";
  }
}

const statusIcon = {
  Created: <BiSolidMessageSquareAdd color="green" size={17} />,
  Modified: <FaEdit color="orange" />,
  Deleted: <FaTrash color="red" />,
  ChangedBranch: <FaExchangeAlt color="orange" />,
  ChangedStatusGreen: <GrStatusGood color="green" />,
  ChangedStatusOrange: <GrStatusGood color="orange" />,
  storeChanged: <BiSolidMessageSquareAdd size={17} color="green" />,
  priceChanged: <IoPricetagsOutline size={17} color="red" />,
};

const isEmpty = (value: any) =>
  value === null ||
  value === undefined ||
  value === "" ||
  value === "-" ||
  (Array.isArray(value) && value.length === 0);

const getStatusType = (oldValue: any, newValue: any) => {
  // console.log("🔍 Checking status:", {
  //   oldValue,
  //   newValue,
  //   oldEmpty: isEmpty(oldValue),
  //   newEmpty: isEmpty(newValue),
  // });

  const oldEmpty = isEmpty(oldValue);
  const newEmpty = isEmpty(newValue);

  if (oldEmpty && !newEmpty) {
    return "Created"; // only new value exists
  } else if (!oldEmpty && !newEmpty) {
    return "Modified"; // both values exist
  } else if (!oldEmpty && newEmpty) {
    return "Deleted"; // only old value exists
  }
  return null; // both empty (no change)
};

const ExpandMore = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }: any) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const variantPropName = (unit: string) => {
  switch (unit) {
    case "policyCategoryId":
      return "Coverage";
    case "policyProductId":
      return "Product Description";
    case "policyIsLifeTimeExpiryDate":
      return "Expiry Date";
    case "policyExpiryDate":
      return "Expiry Date";
    case "policyCoversionDate":
      return "Coversion Date";
    case "policyRenewalDate":
      return "Renewal Date";
    case "policyPaidUpDate":
      return "Paid Up Date";
    case "policyPremiumDetails":
      return "Premium Details";
    case "policyCoverageAmount":
      return "Coverage Amount";
    case "policyInsuredDetails":
      return "Insured Details";
    case "policyPrimaryBenificariesNew":
      return "Primary Benificaries";
    case "policyContengentBenificariesNew":
      return "Contengent Benificaries";
    case "policySummaryReportArray":
      return "Summary Report";
    case "policyRemark":
      return "Remark";
    case "coverageOrderNumber":
      return "Order Number";
    case "policyOfficeUse":
      return "Office Use";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState<Section>(Section.Policy);
  const [currentSearchQueryProject, setCurrentSearchQueryProject] =
    useState("");

  const { customerId, policyNumber } = useParams<{
    customerId: string;
    policyNumber: string;
  }>();

  const { showErrorMessage, showMessage } = useNotifier();

  const [openDeleteProject, setOpenDeleteProject] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState<IPolicy | null>(null);
  const [projectToDeleteCategory, setProjectToDeleteCategory] = useState<
    string | undefined
  >("");

  const [selectedProduct, setSelectedProduct] = useState<IPolicy | null>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedProductSummary, setSelectedProductSummary] =
    useState<IPolicy | null>(null);
  const [openDialogSummary, setOpenDialogSummary] = useState(false);
  const [selectedProductOffice, setSelectedProductOffice] =
    useState<IPolicy | null>(null);
  const [expandedTemplateIdHis, setExpandedTemplateIdHis] = useState<
    number | null
  >(null);

  const [openDialogOffice, setOpenDialogOffice] = useState(false);
  useEffect(() => {}, [customerId]);

  const { data, isLoading, isError } = useGetCustomerQuery({
    searchText: "",
    id: String(customerId),
  });

  const {
    data: customerProjectData,
    isLoading: customerProjectDataIsLoading,
    refetch: cutomerProjectRefetch,
  } = useGetAllByPolicyNumberQuery({
    searchText: currentSearchQueryProject,
    id: "",
    policyCustomerId: String(customerId),
    policyNumber: String(policyNumber),
  });

  const {
    data: coverageHistoryData,
    isLoading: coverageHistoryIsLoading,
    refetch: coverageHistoryRefetch,
  } = useGetAllByCoverageHistoryQuery({
    searchText: currentSearchQueryProject,
    id: "",
    policyCustomerId: String(customerId),
    policyNumber: String(policyNumber),
  });

  const {
    data: productData,
    isLoading: productDataIsLoading,
    isError: productDataError,
  } = useGetProductQuery({
    searchText: "",
    id: "",
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const { data: brandListData, isLoading: brandIsLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const policyCustomerId = String(customerId || "");

  const {
    data: relativeData,
    isLoading: relativeIsLoading,
    isError: relativeError,
  } = useGetCustomerRelationQuery(
    { policyCustomerId },
    { skip: !policyCustomerId }
  );

  const { data: userListData, isLoading: userIsLoading } =
    useGetUserInfoOnyQuery({
      searchText: "",
    });

  const { data: categoryNameData, isLoading: categoryNameDataIsLoading } =
    useGetAllCategoryNameQuery();

  const brandList = useMemo(() => {
    return brandListData?.data as IProductBrand[];
  }, [brandListData?.data]);

  const productList = useMemo(() => {
    return productData?.data as IProductPopUP[];
  }, [productData?.data]);

  const relationDataList = useMemo(() => {
    return (relativeData?.data ?? []) as ICustomerRelative2[];
  }, [relativeData?.data]);

  const relativeList = useMemo(() => {
    return relativeData?.data as ICustomerRelative[];
  }, [relativeData?.data]);

  const userList = useMemo(() => {
    return userListData?.data as IUserAdmin[];
  }, [userListData?.data]);

  const categoryGetAllList = useMemo(() => {
    return categoryNameData?.data as ICategory[];
  }, [categoryNameData?.data]);

  const productMap = useMemo(() => {
    const map = new Map();
    productList?.forEach((brand) => {
      map.set(brand.id, brand.productName);
    });
    return map;
  }, [productList]);

  const brandMap = useMemo(() => {
    const map = new Map();
    brandList?.forEach((category) => {
      map.set(category.id, category.productBrandName);
    });
    return map;
  }, [brandList]);

  const relativeMap = useMemo(() => {
    const map = new Map();
    relationDataList?.forEach((item) => {
      map.set(item.id, `${toProperCase(item?.related_customer_name)}`);
    });
    return map;
  }, [relationDataList]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const typofCoverageMap = useMemo(() => {
    const map = new Map();
    categoryGetAllList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryGetAllList]);

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ICustomer;
    }
    return null;
  }, [data]);

  const project: IPolicy[] = useMemo(() => {
    if (customerProjectData && Array.isArray(customerProjectData.data)) {
      return customerProjectData.data as IPolicy[];
    }
    return [];
  }, [customerProjectData]);

  const historyRecords: IPolicyHistoryRecords[] = Array.isArray(
    coverageHistoryData?.data
  )
    ? (coverageHistoryData?.data as IPolicyHistoryRecords[])
    : [];

  const getChangedFields = (
    current: IPolicy,
    prev: IPolicy | null,
    maps: {
      brandMap: Map<number, string>;
      relativeMap: Map<number, string>;
      relatedCustomerIdMap?: Map<number, number>;
      productMap: Map<number, string>;
      typofCoverageMap: Map<number, string>;
    }
  ) => {
    if (!prev) return [];

    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const isEmpty = (value: any) =>
      value === null ||
      value === undefined ||
      value === "" ||
      value === "-" ||
      (Array.isArray(value) && value.length === 0);

    const formatFieldValue = (
      field: keyof IPolicy,
      value: any
    ): string | string[] => {
      if (value === undefined || value === null) return "-";

      switch (field) {
        case "policyIsLifeTimeExpiryDate":
          return value ? "Death" : "";
        case "policyExpiryDate":
        case "policyCoversionDate":
        case "policyRenewalDate":
        case "policyPaidUpDate":
          return dayjs(value).format("MMM D, YYYY");

        case "policyCategoryId":
          return (
            maps.typofCoverageMap.get(Number(value)) || `Category #${value}`
          );
        case "policyProductId":
          return maps.productMap.get(Number(value)) || `Product #${value}`;

        // ---- ARRAY FIELDS ----
        case "policyContengentBenificariesNew":
          if (!Array.isArray(value)) return "";
          return value
            .map((item) => {
              if (!item) return "";
              const name = maps.relativeMap.get(Number(item.column1)) || "";
              return item.payoutPercentage
                ? `${name} - ${item.payoutPercentage}%`
                : name;
            })
            .filter(Boolean)
            .join(", ");

        case "policyPrimaryBenificariesNew":
          if (!Array.isArray(value)) return "";
          return value
            .map((item) => {
              if (!item) return "";
              const name = maps.relativeMap.get(Number(item.column1)) || "";
              let formatted = name;
              if (item.payoutPercentage) {
                formatted += ` - ${item.payoutPercentage}%`;
              }
              if (item.column2) {
                formatted += ` (${item.column2})`;
              }
              return formatted;
            })
            .filter(Boolean)
            .join(", ");

        case "policyInsuredDetails":
          if (!Array.isArray(value)) return "";
          return value
            .map((insuredId) => {
              const name = maps.relativeMap.get(Number(insuredId)) || "";
              return name;
            })
            .filter(Boolean)
            .join(", ");

        case "policySummaryReportArray":
          if (!Array.isArray(value)) return "";
          return value
            .map((item) => {
              if (typeof item === "string") return item;
              if (typeof item === "object" && item !== null) {
                return item.policyTermsDescription || JSON.stringify(item);
              }
              return String(item);
            })
            .filter(Boolean)
            .join(", ");

        // ---- SIMPLE STRINGS/NUMBERS ----
        case "coverageOrderNumber":
        case "policyPremiumDetails":
        case "policyCoverageAmount":
        case "policyRemark":
          return String(value);
        case "policyOfficeUse":
          return String(value);

        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof IPolicy)[] = [
      "coverageOrderNumber",
      "policyCategoryId",
      "policyProductId",
      "policyIsLifeTimeExpiryDate",
      "policyExpiryDate",
      "policyCoversionDate",
      "policyRenewalDate",
      "policyPaidUpDate",
      "policyPremiumDetails",
      "policyCoverageAmount",
      "policyRemark",
      "policyOfficeUse",
      "policyInsuredDetails",
      "policySummaryReportArray",
      "policyContengentBenificariesNew",
      "policyPrimaryBenificariesNew",
    ];

    return fieldsToCheck
      .map((field) => {
        const oldVal = formatFieldValue(field, prev[field]);
        const newVal = formatFieldValue(field, current[field]);

        // Skip if both are empty (for arrays or empty strings)
        if (isEmpty(oldVal) && isEmpty(newVal)) return null;

        // Skip if arrays are identical
        if (Array.isArray(oldVal) && Array.isArray(newVal)) {
          const arraysEqual =
            oldVal.length === newVal.length &&
            oldVal.every((val, idx) => val === newVal[idx]);
          if (arraysEqual) return null;
        }

        // Skip if primitive values are identical
        if (!Array.isArray(oldVal) && oldVal === newVal) return null;

        return {
          field,
          oldValue: oldVal,
          newValue: newVal,
        };
      })
      .filter(Boolean) as {
      field: keyof IPolicy;
      oldValue: string | string[];
      newValue: string | string[];
    }[];
  };

  const getCreatedFields = (
    current: IPolicy,
    maps: {
      brandMap: Map<number, string>;
      relativeMap: Map<number, string>;
      relatedCustomerIdMap?: Map<number, number>;
      productMap: Map<number, string>;
      typofCoverageMap: Map<number, string>;
    }
  ) => {
    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const formatFieldValue = (
      field: keyof IPolicy,
      value: any
    ): string | string[] => {
      if (value === undefined || value === null || value === "") return "";

      switch (field) {
        case "policyIsLifeTimeExpiryDate":
          return value ? "Death" : "";
        case "policyExpiryDate":
        case "policyCoversionDate":
        case "policyRenewalDate":
        case "policyPaidUpDate":
          return dayjs(value).format("MMM D, YYYY");

        case "policyCategoryId":
          return (
            maps.typofCoverageMap.get(Number(value)) || `Category #${value}`
          );
        case "policyProductId":
          return maps.productMap.get(Number(value)) || `Product #${value}`;

        // ---- ARRAY FIELDS ----
        case "policyContengentBenificariesNew":
          if (!Array.isArray(value)) return "";
          return value
            .map((item) => {
              if (!item) return "";
              const name = maps.relativeMap.get(Number(item.column1)) || "";
              return item.payoutPercentage
                ? `${name} - ${item.payoutPercentage}%`
                : name;
            })
            .filter(Boolean)
            .join(", ");

        case "policyPrimaryBenificariesNew":
          if (!Array.isArray(value)) return "";
          return value
            .map((item) => {
              if (!item) return "";
              const name = maps.relativeMap.get(Number(item.column1)) || "";
              let formatted = name;
              if (item.payoutPercentage) {
                formatted += ` - ${item.payoutPercentage}%`;
              }
              if (item.column2) {
                formatted += ` (${item.column2})`;
              }
              return formatted;
            })
            .filter(Boolean)
            .join(", ");

        case "policyInsuredDetails":
          if (!Array.isArray(value)) return "";
          return value
            .map((insuredId) => {
              const name = maps.relativeMap.get(Number(insuredId)) || "";
              return name;
            })
            .filter(Boolean)
            .join(", ");

        case "policySummaryReportArray":
          if (!Array.isArray(value)) return "";
          return value
            .map((item) => {
              if (typeof item === "string") return item;
              if (typeof item === "object" && item !== null) {
                return item.policyTermsDescription || JSON.stringify(item);
              }
              return String(item);
            })
            .filter(Boolean)
            .join(", ");

        // ---- SIMPLE STRINGS/NUMBERS ----
        case "coverageOrderNumber":
        case "policyPremiumDetails":
        case "policyCoverageAmount":
        case "policyRemark":
        case "policyOfficeUse":
          return `${value}`;

        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof IPolicy)[] = [
      "coverageOrderNumber",
      "policyCategoryId",
      "policyProductId",
      "policyIsLifeTimeExpiryDate",
      "policyExpiryDate",
      "policyCoversionDate",
      "policyRenewalDate",
      "policyPaidUpDate",
      "policyPremiumDetails",
      "policyCoverageAmount",
      "policyRemark",
      "policyOfficeUse",
      "policyInsuredDetails",
      "policySummaryReportArray",
      "policyContengentBenificariesNew",
      "policyPrimaryBenificariesNew",
    ];

    return fieldsToCheck
      .map((field) => {
        const formatted = formatFieldValue(field, current[field]);
        if (
          (Array.isArray(formatted) && formatted.length > 0) ||
          (!Array.isArray(formatted) && formatted)
        ) {
          return { field, value: formatted };
        }
        return null;
      })
      .filter(Boolean) as { field: keyof IPolicy; value: string | string[] }[];
  };

  const firstPolicy = project[0] || {};
  const [deleteCategory] = useDeletePolicyMutation();
  const [deleteFristUpdate] = useDeletePolicyFristIndexMutation();

  const handleDelete = async (id: string) => {
    try {
      // const response = await deleteCategory(id).unwrap();
      let response;

      if (projectToDeleteCategory === "update") {
        response = await deleteFristUpdate(id).unwrap();
      } else if (projectToDeleteCategory === "delete") {
        response = await deleteCategory(id).unwrap();
      }
      if (response?.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProject(false);
      } else {
        showErrorMessage("Failed to delete the Policy");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Policy");
    }
  };

  const handleOpenDeleteProjectPopup = (project: IPolicy, category: string) => {
    setProjectToDelete(project);
    setOpenDeleteProject(true);
    setProjectToDeleteCategory(category);
  };

  const handleCloseDeleteProjectPopup = () => {
    setProjectToDelete(null);
    setOpenDeleteProject(false);
    setProjectToDeleteCategory(undefined);
  };

  const relatedCustomerIdMap = useMemo(() => {
    const map = new Map<number, number>();
    relationDataList?.forEach((item) => {
      if (item?.related_customer_id != null) {
        map.set(item.id, item.related_customer_id);
      }
    });
    return map;
  }, [relationDataList]);

  const hasPolicyData =
    !!firstPolicy &&
    (firstPolicy.policyProductId ||
      firstPolicy.policyCoverageAmount ||
      firstPolicy.policyPremiumDetails ||
      firstPolicy.policyPrimaryBenificariesNew?.length > 0 ||
      firstPolicy.policyContengentBenificariesNew?.length > 0 ||
      firstPolicy.policyInsuredDetails?.length > 0 ||
      firstPolicy.policyIsLifeTimeExpiryDate ||
      firstPolicy.policyExpiryDate ||
      firstPolicy.policyCoversionDate ||
      firstPolicy.policyRenewalDate ||
      firstPolicy.policyPaidUpDate);

  if (
    isLoading ||
    customerProjectDataIsLoading ||
    productDataIsLoading ||
    brandIsLoading ||
    coverageHistoryIsLoading ||
    relativeIsLoading ||
    categoryNameDataIsLoading ||
    userIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching customer data. Please try again later.
      </Typography>
    );
  }

  if (!customer) {
    return <Typography>No customer data available.</Typography>;
  }

  const handleOpenDialog = (product: IPolicy) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleOpenDialogSummary = (product: IPolicy) => {
    setSelectedProductSummary(product);
    setOpenDialogSummary(true);
  };

  const handleCloseDialogSummary = () => {
    setSelectedProductSummary(null);
    setOpenDialogSummary(false);
  };

  const handleCloseDialogOffice = () => {
    setSelectedProductOffice(null);
    setOpenDialogOffice(false);
  };

  const toggleExpandHis = (id: number) => {
    setExpandedTemplateIdHis((prev) => (prev === id ? null : id));
  };

  const renderContent = () => {
    switch (activeSection) {
      case Section.Policy:
        return (
          <Grid container spacing={2}>
            <>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                {project.length == 1 ? (
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid container spacing={2} p={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={1} p={2}>
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Grid
                                    container
                                    spacing={1}
                                    justifyContent="flex-end"
                                    sx={{ display: "flex" }}
                                  >
                                    <Grid item>
                                      <Link
                                        to={`/basic/deal/${firstPolicy.id}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Button
                                          variant="contained"
                                          className={
                                            classes.editButtonListProfile
                                          }
                                          onClick={() =>
                                            navigate(
                                              `/basic/deal/${firstPolicy.id}`
                                            )
                                          }
                                        >
                                          <BorderColorRoundedIcon
                                            className={
                                              classes.editListIconProfileAddColor
                                            }
                                          />
                                        </Button>
                                      </Link>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={6} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="left">
                                    {firstPolicy.policyNumber && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Policy No
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {firstPolicy.policyNumber || " "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {customer &&
                                      (customer.customerFirstName ||
                                        customer.customerLastName) && (
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid
                                            container
                                            className={classes.profileDetails}
                                            spacing={1}
                                          >
                                            <Grid
                                              item
                                              lg={5}
                                              md={4}
                                              sm={4}
                                              xs={4}
                                            >
                                              <Typography
                                                className={classes.text12}
                                              >
                                                Policy Owner
                                                <span
                                                  style={{ float: "right" }}
                                                >
                                                  :
                                                </span>
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={7}
                                              md={8}
                                              sm={8}
                                              xs={8}
                                            >
                                              <Typography
                                                className={classes.text123}
                                              >
                                                <Link
                                                  to={`/profile/customer/${customer.id}`}
                                                  className={
                                                    classes.iconLinkPropNormal
                                                  }
                                                >
                                                  <span
                                                    style={{
                                                      cursor: "pointer",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                    }}
                                                    // onClick={() =>
                                                    //   navigate(
                                                    //     `/profile/customer/${customer.id}`
                                                    //   )
                                                    // }
                                                  >
                                                    {toProperCase(
                                                      customer?.customerFirstName ||
                                                        ""
                                                    ) +
                                                      " " +
                                                      toProperCase(
                                                        customer?.customerLastName ||
                                                          ""
                                                      )}
                                                    <FontAwesomeIcon
                                                      icon={faUser}
                                                      style={{
                                                        color: "#1976d2",
                                                      }}
                                                    />
                                                  </span>
                                                </Link>
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                    {firstPolicy.policyInsuranceCompanyId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Insurance Company
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {brandMap.get(
                                                Number(
                                                  firstPolicy.policyInsuranceCompanyId
                                                )
                                              ) || ""}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.jointPolicyOwnerId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Jo Po Owner
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              <Link
                                                to={`/profile/customer/${relatedCustomerIdMap.get(
                                                  Number(
                                                    firstPolicy.jointPolicyOwnerId
                                                  )
                                                )}`}
                                                className={
                                                  classes.iconLinkPropNormal
                                                }
                                              >
                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                  }}
                                                  // onClick={() => {
                                                  //   const relative =
                                                  //     relativeList.find(
                                                  //       (c) =>
                                                  //         c.id ===
                                                  //         Number(
                                                  //           firstPolicy.jointPolicyOwnerId
                                                  //         )
                                                  //     );
                                                  //   if (
                                                  //     relative?.related_customer_id
                                                  //   ) {
                                                  //     navigate(
                                                  //       `/profile/customer/${relative.related_customer_id}`
                                                  //     );
                                                  //   }
                                                  // }}
                                                >
                                                  {relativeMap.get(
                                                    Number(
                                                      firstPolicy.jointPolicyOwnerId
                                                    )
                                                  ) || ""}
                                                  <FontAwesomeIcon
                                                    icon={faUser}
                                                    style={{ color: "#1976d2" }}
                                                  />
                                                </span>
                                              </Link>
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.contengentPolicyOwnerId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Co. Po Owner
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              <Link
                                                to={`/profile/customer/${relatedCustomerIdMap.get(
                                                  Number(
                                                    firstPolicy.contengentPolicyOwnerId
                                                  )
                                                )}`}
                                                className={
                                                  classes.iconLinkPropNormal
                                                }
                                              >
                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                  }}
                                                  // onClick={() => {
                                                  //   const relative =
                                                  //     relativeList.find(
                                                  //       (c) =>
                                                  //         c.id ===
                                                  //         Number(
                                                  //           firstPolicy.contengentPolicyOwnerId
                                                  //         )
                                                  //     );
                                                  //   if (
                                                  //     relative?.related_customer_id
                                                  //   ) {
                                                  //     navigate(
                                                  //       `/profile/customer/${relative.related_customer_id}`
                                                  //     );
                                                  //   }
                                                  // }}
                                                >
                                                  {relativeMap.get(
                                                    Number(
                                                      firstPolicy.contengentPolicyOwnerId
                                                    )
                                                  ) || ""}
                                                  <FontAwesomeIcon
                                                    icon={faUser}
                                                    style={{ color: "#1976d2" }}
                                                  />
                                                </span>
                                              </Link>
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>

                                <Grid item lg={6} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="left">
                                    {firstPolicy.policyPremium && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Premium
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {formatNumber(
                                                firstPolicy.policyPremium ||
                                                  "0.00"
                                              )}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.policyIssueDate && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Issue Date
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {firstPolicy.policyIssueDate
                                                ? dayjs(
                                                    firstPolicy.policyIssueDate
                                                  ).format("MMM D, YYYY")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.policyPremiumFrequency && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Premium Frequency
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {getPolicyCollectionType(
                                                firstPolicy.policyPremiumFrequency
                                              ) || " "}
                                              {[
                                                "Annually",
                                                "Custom",
                                                "OneTime",
                                              ].includes(
                                                firstPolicy.policyPremiumFrequency
                                              ) &&
                                                (firstPolicy.policyPremiumFrequencyDate
                                                  ? ` - ${dayjs(
                                                      firstPolicy.policyPremiumFrequencyDate
                                                    ).format("MMM D, YYYY")}`
                                                  : "")}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.policyDrawDay && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Draw Day
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {firstPolicy.policyDrawDay || " "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.policyPayor && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Payor
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {firstPolicy.policyPayor || " "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Card
                            className={classes.cardNonRedius}
                            sx={{
                              borderStartEndRadius: "5px",
                              borderStartStartRadius: "5px",
                              // minHeight: 300,
                            }}
                          >
                            <Grid
                              container
                              justifyContent={"space-between"}
                              spacing={2}
                              sx={{ px: 4, py: 2 }}
                              className={classes.activityHistoryHeaderGrid}
                            >
                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                pt={2}
                                alignContent={"center"}
                              >
                                <Typography
                                  className={classes.ActivityHistoryHEading}
                                >
                                  Coverage
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Grid
                                  container
                                  spacing={1}
                                  justifyContent="flex-end"
                                  sx={{ display: "flex" }}
                                >
                                  <Grid item>
                                    <Button
                                      size="small"
                                      // variant="contained"
                                      className={classes.addNewButton}
                                      onClick={() => {
                                        if (hasPolicyData) {
                                          navigate(
                                            `/customer/${customerId}/coverage/${firstPolicy.id}`
                                          );
                                        } else {
                                          navigate(
                                            `/coverage/deal/${firstPolicy.id}`
                                          );
                                        }
                                      }}
                                    >
                                      Add Coverage
                                    </Button>
                                  </Grid>
                                  {hasPolicyData && (
                                    <Grid item>
                                      <Link
                                        to={`/coverage-report/customer/${customerId}/policy/${policyNumber}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Button
                                          size="small"
                                          // variant="contained"
                                          className={classes.addNewButton}
                                          // onClick={() =>
                                          //   navigate(
                                          //     `/coverage-report/customer/${customerId}/policy/${policyNumber}`
                                          //   )
                                          // }
                                        >
                                          Generate Report
                                        </Button>
                                      </Link>
                                    </Grid>
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          </Card>
                        </Grid>
                        {hasPolicyData ? (
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            {/* <Card className={classes.cardNonRedius}> */}
                            {project.map((policy, index) => {
                              let backgroundColor;
                              if (index % 2 === 0) {
                                backgroundColor = "#ffffff";
                              } else if (index % 2 === 1) {
                                backgroundColor = "#ffffff";
                              } else {
                                backgroundColor = "#ffffff";
                              }

                              return (
                                <Grid
                                  key={policy.id}
                                  container
                                  sx={{
                                    backgroundColor: backgroundColor,
                                  }}
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    pt={2}
                                    sx={{
                                      backgroundColor: "#99aabf",
                                      px: 4,
                                      py: "10px",
                                    }}
                                  >
                                    <Grid
                                      container
                                      spacing={2}
                                      alignItems="center"
                                    >
                                      <Grid
                                        item
                                        xs
                                        display="flex"
                                        flexDirection="row"
                                        alignItems="center"
                                        gap={2}
                                      >
                                        {policy.coverageOrderNumber != null && (
                                          <Box
                                            className={classes.orderNumberBox}
                                          >
                                            <Typography
                                              className={
                                                classes.ActivityHistoryHEadingWhite
                                              }
                                            >
                                              {policy.coverageOrderNumber}
                                            </Typography>
                                          </Box>
                                        )}

                                        {policy.policyProductId && (
                                          <Link
                                            to={`/policy-history/${policy.policyProductId}`}
                                            className={
                                              classes.iconLinkPropNormal
                                            }
                                          >
                                            <Typography
                                              className={
                                                classes.ActivityHistoryHEadingWhite
                                              }
                                            >
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                {productMap.get(
                                                  policy.policyProductId
                                                ) || ""}
                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    paddingLeft: "5px",
                                                  }}
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faLink}
                                                    style={{ color: "#1976d2" }}
                                                  />
                                                </span>
                                              </span>
                                            </Typography>
                                          </Link>
                                        )}

                                        {policy.policyCoverageAmount && (
                                          <Typography
                                            variant="h4"
                                            className={
                                              classes.contactInfoProfileWhite
                                            }
                                          >
                                            {/* {Number(
                                            policy.policyCoverageAmount ?? 0
                                          ).toFixed(2)} */}
                                            {formatNumber(
                                              policy.policyCoverageAmount ?? 0
                                            )}
                                          </Typography>
                                        )}
                                      </Grid>

                                      {/* <Grid item>
                                        {policy.policyPremiumDetails && (
                                          <Typography
                                            variant="h4"
                                            className={
                                              classes.contactInfoProfile
                                            }
                                          >
                                            $ {policy.policyPremiumDetails}
                                          </Typography>
                                        )}
                                      </Grid> */}

                                      <Grid item>
                                        <Link
                                          to={`/coverage/deal/${policy.id}`}
                                          className={classes.iconLinkPropNormal}
                                        >
                                          <Button
                                            variant="contained"
                                            className={
                                              classes.editButtonListProfile
                                            }
                                            // onClick={() =>
                                            //   navigate(
                                            //     `/coverage/deal/${policy.id}`
                                            //   )
                                            // }
                                          >
                                            <BorderColorRoundedIcon
                                              className={
                                                classes.editListIconProfileAddColor
                                              }
                                            />
                                          </Button>
                                        </Link>
                                      </Grid>

                                      <Grid item>
                                        <Button
                                          variant="contained"
                                          className={
                                            classes.deleteButtonListProfilepage
                                          }
                                          onClick={() =>
                                            handleOpenDeleteProjectPopup(
                                              policy,
                                              "update"
                                            )
                                          }
                                        >
                                          <DeleteOutlineSharpIcon
                                            className={
                                              classes.editListIconProfileAddColor
                                            }
                                          />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    pt={2}
                                    alignContent={"center"}
                                    sx={{
                                      px: 4,
                                      py: 2,
                                      // minHeight: "300px",
                                    }}
                                  >
                                    <Grid
                                      container
                                      spacing={1}
                                      alignItems="left"
                                    >
                                      <Grid item lg={8} md={12} sm={12} xs={12}>
                                        <Grid
                                          container
                                          spacing={1}
                                          alignItems="left"
                                        >
                                          {policy.policyPremiumDetails && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid
                                                container
                                                className={
                                                  classes.profileDetails
                                                }
                                              >
                                                <Grid
                                                  item
                                                  lg={4}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text2}
                                                  >
                                                    Premium Details
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={8}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text23}
                                                  >
                                                    {": "}
                                                    {/* {Number(
                                                    policy.policyPremiumDetails ??
                                                      0
                                                  ).toFixed(2)} */}
                                                    {formatNumber(
                                                      policy.policyPremiumDetails ??
                                                        0
                                                    )}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          )}

                                          {policy.policyInsuredDetails.length >
                                            0 && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid
                                                container
                                                className={
                                                  classes.profileDetails
                                                }
                                              >
                                                <Grid
                                                  item
                                                  lg={4}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text2}
                                                  >
                                                    Insured
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={8}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text23}
                                                  >
                                                    {": "}

                                                    {policy.policyInsuredDetails.map(
                                                      (insuredId, index) => {
                                                        const customerName =
                                                          relativeMap.get(
                                                            Number(insuredId)
                                                          ) || "";

                                                        return (
                                                          <Link
                                                            to={`/profile/customer/${relatedCustomerIdMap.get(
                                                              Number(insuredId)
                                                            )}`}
                                                            className={
                                                              classes.iconLinkPropNormal
                                                            }
                                                          >
                                                            <span
                                                              key={insuredId}
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() => {
                                                                const relative =
                                                                  relativeList.find(
                                                                    (c) =>
                                                                      c.id ===
                                                                      Number(
                                                                        insuredId
                                                                      )
                                                                  );
                                                                if (
                                                                  relative?.related_customer_id
                                                                ) {
                                                                  navigate(
                                                                    `/profile/customer/${relative.related_customer_id}`
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              {customerName}
                                                              <span
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  display:
                                                                    "inline-flex",
                                                                  alignItems:
                                                                    "center",
                                                                  paddingLeft:
                                                                    "2px",
                                                                  paddingRight:
                                                                    "1px",
                                                                }}
                                                              >
                                                                <FontAwesomeIcon
                                                                  icon={faUser}
                                                                  style={{
                                                                    color:
                                                                      "#1976d2",
                                                                  }}
                                                                />
                                                              </span>
                                                              {index <
                                                                policy
                                                                  .policyInsuredDetails
                                                                  .length -
                                                                  1 && ", "}
                                                            </span>
                                                          </Link>
                                                        );
                                                      }
                                                    )}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          )}

                                          {policy.policyPrimaryBenificariesNew
                                            .length > 0 && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid
                                                container
                                                className={
                                                  classes.profileDetails
                                                }
                                              >
                                                <Grid
                                                  item
                                                  lg={4}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text2}
                                                  >
                                                    Prim Benefi
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={8}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text23}
                                                  >
                                                    {": "}
                                                    {/* {policy
                                                      .policyPrimaryBenificariesNew
                                                      ?.length > 0
                                                      ? policy.policyPrimaryBenificariesNew.map(
                                                          (insured, index) => (
                                                            <span key={index}>
                                                              {toProperCase(
                                                                insured.name
                                                              )}{" "}
                                                              {insured.payoutPercentage
                                                                ? `- ${insured.payoutPercentage}%`
                                                                : ""}
                                                              {index <
                                                                policy
                                                                  .policyPrimaryBenificariesNew
                                                                  .length -
                                                                  1 && ", "}
                                                            </span>
                                                          )
                                                        )
                                                      : toProperCase(
                                                          policy.policyPrimaryBenificaries ||
                                                            ""
                                                        )} */}

                                                    {policy.policyPrimaryBenificariesNew.map(
                                                      (insuredId, index) => {
                                                        const customerName =
                                                          relativeMap.get(
                                                            Number(
                                                              insuredId.column1
                                                            )
                                                          ) || "";

                                                        return (
                                                          <Link
                                                            to={`/profile/customer/${relatedCustomerIdMap.get(
                                                              Number(
                                                                insuredId.column1
                                                              )
                                                            )}`}
                                                            className={
                                                              classes.iconLinkPropNormal
                                                            }
                                                          >
                                                            <span
                                                              key={index}
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() => {
                                                                const relative =
                                                                  relativeList.find(
                                                                    (c) =>
                                                                      c.id ===
                                                                      Number(
                                                                        insuredId
                                                                      )
                                                                  );
                                                                if (
                                                                  relative?.related_customer_id
                                                                ) {
                                                                  navigate(
                                                                    `/profile/customer/${relative.related_customer_id}`
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              {customerName}
                                                              {insuredId.payoutPercentage
                                                                ? `- ${insuredId.payoutPercentage}%`
                                                                : ""}
                                                              {insuredId.column2
                                                                ? ` (${insuredId.column2})`
                                                                : ""}
                                                              <span
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  display:
                                                                    "inline-flex",
                                                                  alignItems:
                                                                    "center",
                                                                  paddingLeft:
                                                                    "2px",
                                                                  paddingRight:
                                                                    "1px",
                                                                }}
                                                              >
                                                                <FontAwesomeIcon
                                                                  icon={faUser}
                                                                  style={{
                                                                    color:
                                                                      "#1976d2",
                                                                  }}
                                                                />
                                                              </span>
                                                              {index <
                                                                policy
                                                                  .policyPrimaryBenificariesNew
                                                                  .length -
                                                                  1 && ", "}
                                                            </span>
                                                          </Link>
                                                        );
                                                      }
                                                    )}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          )}

                                          {policy
                                            .policyContengentBenificariesNew
                                            .length > 0 && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid
                                                container
                                                className={
                                                  classes.profileDetails
                                                }
                                              >
                                                <Grid
                                                  item
                                                  lg={4}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text2}
                                                  >
                                                    Cont Benefi
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={8}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text23}
                                                  >
                                                    {": "}
                                                    {policy.policyContengentBenificariesNew.map(
                                                      (insuredId, index) => {
                                                        const customerName =
                                                          relativeMap.get(
                                                            Number(
                                                              insuredId.column1
                                                            )
                                                          ) || "";

                                                        return (
                                                          <Link
                                                            to={`/profile/customer/${relatedCustomerIdMap.get(
                                                              Number(
                                                                insuredId.column1
                                                              )
                                                            )}`}
                                                            className={
                                                              classes.iconLinkPropNormal
                                                            }
                                                          >
                                                            <span
                                                              key={index}
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() => {
                                                                const relative =
                                                                  relativeList.find(
                                                                    (c) =>
                                                                      c.id ===
                                                                      Number(
                                                                        insuredId
                                                                      )
                                                                  );
                                                                if (
                                                                  relative?.related_customer_id
                                                                ) {
                                                                  navigate(
                                                                    `/profile/customer/${relative.related_customer_id}`
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              {customerName}
                                                              {insuredId.payoutPercentage
                                                                ? `- ${insuredId.payoutPercentage}%`
                                                                : ""}

                                                              <span
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  display:
                                                                    "inline-flex",
                                                                  alignItems:
                                                                    "center",
                                                                  paddingLeft:
                                                                    "2px",
                                                                  paddingRight:
                                                                    "1px",
                                                                }}
                                                              >
                                                                <FontAwesomeIcon
                                                                  icon={faUser}
                                                                  style={{
                                                                    color:
                                                                      "#1976d2",
                                                                  }}
                                                                />
                                                              </span>
                                                              {index <
                                                                policy
                                                                  .policyContengentBenificariesNew
                                                                  .length -
                                                                  1 && ", "}
                                                            </span>
                                                          </Link>
                                                        );
                                                      }
                                                    )}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          )}
                                        </Grid>
                                      </Grid>
                                      <Grid item lg={4} md={12} sm={12} xs={12}>
                                        <Grid
                                          container
                                          spacing={1}
                                          alignItems="left"
                                        >
                                          {(policy.policyIsLifeTimeExpiryDate ||
                                            policy.policyExpiryDate) && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid
                                                container
                                                className={
                                                  classes.profileDetails
                                                }
                                              >
                                                <Grid
                                                  item
                                                  lg={6}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text2}
                                                  >
                                                    Expiry Date
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={6}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text23}
                                                  >
                                                    {": "}
                                                    {policy.policyIsLifeTimeExpiryDate
                                                      ? "Death"
                                                      : policy.policyExpiryDate
                                                      ? dayjs(
                                                          policy.policyExpiryDate
                                                        ).format("MMM D, YYYY")
                                                      : ""}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          )}

                                          {policy.policyCoversionDate && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid
                                                container
                                                className={
                                                  classes.profileDetails
                                                }
                                              >
                                                <Grid
                                                  item
                                                  lg={6}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text2}
                                                  >
                                                    Cov. Date
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={6}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text23}
                                                  >
                                                    {": "}
                                                    {policy.policyCoversionDate
                                                      ? dayjs(
                                                          policy.policyCoversionDate
                                                        ).format("MMM D, YYYY")
                                                      : ""}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          )}

                                          {policy.policyRenewalDate && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid
                                                container
                                                className={
                                                  classes.profileDetails
                                                }
                                              >
                                                <Grid
                                                  item
                                                  lg={6}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text2}
                                                  >
                                                    Renewal Date
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={6}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text23}
                                                  >
                                                    {": "}
                                                    {policy.policyRenewalDate
                                                      ? dayjs(
                                                          policy.policyRenewalDate
                                                        ).format("MMM D, YYYY")
                                                      : ""}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          )}
                                          {policy.policyPaidUpDate && (
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Grid
                                                container
                                                className={
                                                  classes.profileDetails
                                                }
                                              >
                                                <Grid
                                                  item
                                                  lg={6}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text2}
                                                  >
                                                    Paid Up Date
                                                  </Typography>
                                                </Grid>
                                                <Grid
                                                  item
                                                  lg={6}
                                                  md={6}
                                                  sm={6}
                                                  xs={6}
                                                >
                                                  <Typography
                                                    className={classes.text23}
                                                  >
                                                    {": "}
                                                    {policy.policyPaidUpDate
                                                      ? dayjs(
                                                          policy.policyPaidUpDate
                                                        ).format("MMM D, YYYY")
                                                      : ""}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          )}
                                        </Grid>
                                      </Grid>
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          mt: 3,
                                        }}
                                      >
                                        <Grid
                                          container
                                          spacing={1}
                                          justifyContent="flex-end"
                                          sx={{ display: "flex" }}
                                        >
                                          <Grid item>
                                            <Button
                                              size="small"
                                              // variant="contained"
                                              className={classes.addNewButton}
                                              onClick={() =>
                                                handleOpenDialog(policy)
                                              }
                                            >
                                              {/* 🔓 Enable Custom Terms */}
                                              Comments
                                            </Button>
                                          </Grid>
                                          <Grid item>
                                            <Button
                                              size="small"
                                              // variant="contained"
                                              className={classes.addNewButton}
                                              onClick={() =>
                                                handleOpenDialogSummary(policy)
                                              }
                                            >
                                              {/* ➕ Additional Terms */}
                                              Add Additional Comments
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  {/* <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    pt={2}
                                    alignContent={"center"}
                                    sx={{
                                      px: 5,
                                      py: 2,
                                    }}
                                  >
                                    <Grid container alignItems="left">
                                      {policy.policyExpiryDate && (
                                        <Grid
                                          item
                                          lg={6}
                                          md={6}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid
                                            container
                                            className={classes.profileDetails}
                                          >
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Typography variant="subtitle1">
                                                Expiry Date :&nbsp;&nbsp;
                                                {policy.policyExpiryDate
                                                  ? dayjs(
                                                      policy.policyExpiryDate
                                                    ).format("MMM D, YYYY")
                                                  : ""}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid> */}
                                  {policy.policyTermsArray &&
                                    policy.policyTermsArray.length > 0 && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          px: 4,
                                          py: 2,
                                        }}
                                      >
                                        <Grid container spacing={2}>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Box
                                              sx={{
                                                maxHeight: "600px",
                                                minHeight: "auto",
                                                overflow: "auto",
                                                padding: "2px",
                                                "&::-webkit-scrollbar": {
                                                  width: "4px",
                                                },
                                                "&::-webkit-scrollbar-track": {
                                                  background: "#eeeeee",
                                                },
                                                "&::-webkit-scrollbar-thumb": {
                                                  background: "#eeeeee",
                                                  borderRadius: "10px",
                                                },
                                                "&::-webkit-scrollbar-thumb:hover":
                                                  {
                                                    background: "#eeeeee",
                                                  },
                                              }}
                                            >
                                              <Grid
                                                container
                                                alignItems="center"
                                                className={
                                                  classes.titleSummaryReportBox
                                                }
                                              >
                                                <Grid
                                                  container
                                                  spacing={1}
                                                  alignItems="center"
                                                  padding={1}
                                                >
                                                  <Grid
                                                    item
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                    display="flex"
                                                    justifyContent="flex-start"
                                                    alignItems="end"
                                                  >
                                                    <Typography variant="subtitle1">
                                                      Additional Comments
                                                    </Typography>
                                                  </Grid>
                                                  {policy.policyTermsArray &&
                                                  policy.policyTermsArray
                                                    .length > 0 ? (
                                                    policy.policyTermsArray.map(
                                                      (
                                                        item: policyAllPrintTermsArray,
                                                        idx: number
                                                      ) => (
                                                        <Grid
                                                          item
                                                          lg={12}
                                                          md={12}
                                                          sm={12}
                                                          xs={12}
                                                          key={idx}
                                                        >
                                                          <Grid
                                                            container
                                                            spacing={2}
                                                            alignItems="center"
                                                          >
                                                            {/* <Grid
                                                              item
                                                              lg={0.5}
                                                              md={1}
                                                              sm={1}
                                                              xs={1}
                                                              display="flex"
                                                              justifyContent="flex-start"
                                                              alignItems="flex-start"
                                                            >
                                                              <Typography
                                                                sx={{
                                                                  fontSize: 13,
                                                                  display:
                                                                    "flex",
                                                                  justifyContent:
                                                                    "center",
                                                                  alignItems:
                                                                    "center",
                                                                  width: 18,
                                                                  height: 18,
                                                                  borderRadius:
                                                                    "50%",
                                                                  border:
                                                                    "1px solid ",
                                                                  textAlign:
                                                                    "center",
                                                                  lineHeight:
                                                                    "13px",
                                                                }}
                                                              >
                                                                {"✔"}
                                                              </Typography>
                                                            </Grid> */}
                                                            <Grid
                                                              item
                                                              lg={0.5}
                                                              md={1}
                                                              sm={2}
                                                              xs={2}
                                                              display="flex"
                                                              justifyContent="flex-start"
                                                              alignItems="flex-start"
                                                            >
                                                              {item.isReport ? (
                                                                <CheckCircleRoundedIcon
                                                                  sx={{
                                                                    fontSize: 22,
                                                                    color:
                                                                      "#06b57d",
                                                                  }}
                                                                />
                                                              ) : (
                                                                <CancelIcon
                                                                  color="error"
                                                                  sx={{
                                                                    fontSize: 22,
                                                                  }}
                                                                />
                                                              )}
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              lg={11.5}
                                                              md={11}
                                                              sm={10}
                                                              xs={10}
                                                            >
                                                              <Typography
                                                                className={
                                                                  classes.bodyPrint133
                                                                }
                                                                component="div"
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    item.policyTermsDescription,
                                                                }}
                                                              />
                                                              {/* <Typography
                                                                className="headingSummary"
                                                                sx={{
                                                                  pb: "2px",
                                                                }}
                                                              >
                                                                {
                                                                  item.policyTermsDescription
                                                                }
                                                              </Typography> */}
                                                            </Grid>
                                                          </Grid>
                                                        </Grid>
                                                      )
                                                    )
                                                  ) : (
                                                    <Typography
                                                      className="noData"
                                                      sx={{
                                                        textAlign: "center",
                                                        color: "gray",
                                                      }}
                                                    ></Typography>
                                                  )}
                                                </Grid>
                                              </Grid>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                  {policy.policySummaryReportArray &&
                                    policy.policySummaryReportArray.length >
                                      0 && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          px: 4,
                                          py: 2,
                                        }}
                                      >
                                        <Grid container spacing={2}>
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Box
                                              sx={{
                                                maxHeight: "600px",
                                                minHeight: "auto",
                                                overflow: "auto",
                                                padding: "2px",
                                                "&::-webkit-scrollbar": {
                                                  width: "4px",
                                                },
                                                "&::-webkit-scrollbar-track": {
                                                  background: "#eeeeee",
                                                },
                                                "&::-webkit-scrollbar-thumb": {
                                                  background: "#eeeeee",
                                                  borderRadius: "10px",
                                                },
                                                "&::-webkit-scrollbar-thumb:hover":
                                                  {
                                                    background: "#eeeeee",
                                                  },
                                              }}
                                            >
                                              <Grid
                                                container
                                                alignItems="center"
                                                className={
                                                  classes.titleSummaryReportBox
                                                }
                                              >
                                                <Grid
                                                  container
                                                  spacing={1}
                                                  alignItems="center"
                                                  padding={1}
                                                >
                                                  <Grid
                                                    item
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                    display="flex"
                                                    justifyContent="flex-start"
                                                    alignItems="end"
                                                  >
                                                    <Typography
                                                      // className={classes.contactInfoViewPage}
                                                      variant="subtitle1"
                                                    >
                                                      Summary Report
                                                    </Typography>
                                                  </Grid>
                                                  {Array.isArray(
                                                    policy.policySummaryReportArray
                                                  ) &&
                                                  policy
                                                    .policySummaryReportArray
                                                    .length > 0 ? (
                                                    policy.policySummaryReportArray.map(
                                                      (
                                                        item: policyTermsArray,
                                                        idx: number
                                                      ) => (
                                                        <Grid
                                                          item
                                                          lg={12}
                                                          md={12}
                                                          sm={12}
                                                          xs={12}
                                                          key={idx}
                                                        >
                                                          <Grid
                                                            container
                                                            spacing={2}
                                                            alignItems="center"
                                                          >
                                                            {/* <Grid
                                                              item
                                                              lg={0.5}
                                                              md={0.5}
                                                              sm={0.5}
                                                              xs={0.5}
                                                              display="flex"
                                                              justifyContent="flex-start"
                                                              alignItems="flex-start"
                                                            >
                                                              <Typography
                                                                sx={{
                                                                  fontSize: 13,
                                                                  display:
                                                                    "flex",
                                                                  justifyContent:
                                                                    "center",
                                                                  alignItems:
                                                                    "center",
                                                                  width: 18,
                                                                  height: 18,
                                                                  borderRadius:
                                                                    "50%",
                                                                  border:
                                                                    "1px solid ",
                                                                  textAlign:
                                                                    "center",
                                                                  lineHeight:
                                                                    "13px",
                                                                }}
                                                              >
                                                                {"✔"}
                                                              </Typography>
                                                            </Grid> */}
                                                            <Grid
                                                              item
                                                              lg={0.5}
                                                              md={2}
                                                              sm={2}
                                                              xs={2}
                                                              display="flex"
                                                              justifyContent="flex-start"
                                                              alignItems="flex-start"
                                                            >
                                                              {item.isPolicyTermsSummaryReport ? (
                                                                <CheckCircleRoundedIcon
                                                                  sx={{
                                                                    fontSize: 22,
                                                                    color:
                                                                      "#cad00c",
                                                                  }}
                                                                />
                                                              ) : (
                                                                <CancelIcon
                                                                  color="error"
                                                                  sx={{
                                                                    fontSize: 22,
                                                                  }}
                                                                />
                                                              )}
                                                            </Grid>
                                                            <Grid
                                                              item
                                                              lg={11.5}
                                                              md={10}
                                                              sm={10}
                                                              xs={10}
                                                            >
                                                              <Typography
                                                                className={
                                                                  classes.bodyPrint133
                                                                }
                                                                component="div"
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    item.policyTermsDescription,
                                                                }}
                                                              />
                                                              {/* <Typography
                                                                className="headingSummary"
                                                                sx={{
                                                                  pb: "2px",
                                                                }}
                                                              >
                                                                {
                                                                  item.policyTermsDescription
                                                                }
                                                              </Typography> */}
                                                            </Grid>
                                                          </Grid>
                                                        </Grid>
                                                      )
                                                    )
                                                  ) : (
                                                    <Typography
                                                      className="noData"
                                                      sx={{
                                                        textAlign: "center",
                                                        color: "gray",
                                                      }}
                                                    ></Typography>
                                                  )}
                                                </Grid>
                                              </Grid>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}

                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    sx={{
                                      backgroundColor: "#f4fafe",
                                      pt: 3,
                                    }}
                                  ></Grid>

                                  <>
                                    {projectToDelete && (
                                      <DeletePopup
                                        open={openDeleteProject}
                                        handleCloseDelete={
                                          handleCloseDeleteProjectPopup
                                        }
                                        onConfirm={async () => {
                                          await handleDelete(
                                            projectToDelete.id.toString()
                                          );
                                        }}
                                        title="Delete Coverage"
                                        content={`Are you sure you want to delete ${
                                          projectToDelete.policyNumber
                                        }${
                                          productMap.get(
                                            projectToDelete.policyProductId
                                          )
                                            ? ` - ${productMap.get(
                                                projectToDelete.policyProductId
                                              )}`
                                            : ""
                                        }?`}
                                      />
                                    )}
                                  </>
                                </Grid>
                              );
                            })}
                            {/* </Card> */}
                          </Grid>
                        ) : (
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{
                              minHeight: 100,
                            }}
                          >
                            <Card
                              className={classes.cardNonRedius}
                              sx={{
                                minHeight: 300,
                              }}
                            >
                              <Grid container>
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  pt={2}
                                  sx={{
                                    backgroundColor: "#99aabf",
                                    px: 4,
                                    py: "10px",
                                    minHeight: 30,
                                  }}
                                ></Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid container spacing={2} p={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.meetingLable1}>
                              <Grid container spacing={1} p={2}>
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Grid
                                    container
                                    spacing={1}
                                    justifyContent="flex-end"
                                    sx={{ display: "flex" }}
                                  >
                                    <Grid item>
                                      <Link
                                        to={`/basic/deal/${firstPolicy.id}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Button
                                          variant="contained"
                                          className={
                                            classes.editButtonListProfile
                                          }
                                          onClick={() =>
                                            navigate(
                                              `/basic/deal/${firstPolicy.id}`
                                            )
                                          }
                                        >
                                          <BorderColorRoundedIcon
                                            className={
                                              classes.editListIconProfileAddColor
                                            }
                                          />
                                        </Button>
                                      </Link>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                  <Grid container alignItems="left">
                                    {firstPolicy.policyNumber && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Policy No
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {firstPolicy.policyNumber || " "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {customer &&
                                      (customer.customerFirstName ||
                                        customer.customerLastName) && (
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid
                                            container
                                            className={classes.profileDetails}
                                            spacing={1}
                                          >
                                            <Grid
                                              item
                                              lg={5}
                                              md={4}
                                              sm={4}
                                              xs={4}
                                            >
                                              <Typography
                                                className={classes.text12}
                                              >
                                                Policy Owner
                                                <span
                                                  style={{ float: "right" }}
                                                >
                                                  :
                                                </span>
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={7}
                                              md={8}
                                              sm={8}
                                              xs={8}
                                            >
                                              <Typography
                                                className={classes.text123}
                                              >
                                                <Link
                                                  to={`/profile/customer/${customer.id}`}
                                                  className={
                                                    classes.iconLinkPropNormal
                                                  }
                                                >
                                                  <span
                                                    style={{
                                                      cursor: "pointer",
                                                      display: "inline-flex",
                                                      alignItems: "center",
                                                      gap: "6px",
                                                    }}
                                                    // onClick={() =>
                                                    //   navigate(
                                                    //     `/profile/customer/${customer.id}`
                                                    //   )
                                                    // }
                                                  >
                                                    {toProperCase(
                                                      customer?.customerFirstName ||
                                                        ""
                                                    ) +
                                                      " " +
                                                      toProperCase(
                                                        customer?.customerLastName ||
                                                          ""
                                                      )}
                                                    <FontAwesomeIcon
                                                      icon={faUser}
                                                      style={{
                                                        color: "#1976d2",
                                                      }}
                                                    />
                                                  </span>
                                                </Link>
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                    {firstPolicy.policyInsuranceCompanyId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Insurance Company
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {brandMap.get(
                                                Number(
                                                  firstPolicy.policyInsuranceCompanyId
                                                )
                                              ) || ""}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {firstPolicy.jointPolicyOwnerId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Jo Po Owner
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              <Link
                                                to={`/profile/customer/${relatedCustomerIdMap.get(
                                                  Number(
                                                    firstPolicy.jointPolicyOwnerId
                                                  )
                                                )}`}
                                                className={
                                                  classes.iconLinkPropNormal
                                                }
                                              >
                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                  }}
                                                  // onClick={() => {
                                                  //   const relative =
                                                  //     relativeList.find(
                                                  //       (c) =>
                                                  //         c.id ===
                                                  //         Number(
                                                  //           firstPolicy.jointPolicyOwnerId
                                                  //         )
                                                  //     );
                                                  //   if (
                                                  //     relative?.related_customer_id
                                                  //   ) {
                                                  //     navigate(
                                                  //       `/profile/customer/${relative.related_customer_id}`
                                                  //     );
                                                  //   }
                                                  // }}
                                                >
                                                  {relativeMap.get(
                                                    Number(
                                                      firstPolicy.jointPolicyOwnerId
                                                    )
                                                  ) || ""}
                                                  <FontAwesomeIcon
                                                    icon={faUser}
                                                    style={{ color: "#1976d2" }}
                                                  />
                                                </span>
                                              </Link>
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.contengentPolicyOwnerId && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Co. Po Owner
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              <Link
                                                to={`/profile/customer/${relatedCustomerIdMap.get(
                                                  Number(
                                                    firstPolicy.contengentPolicyOwnerId
                                                  )
                                                )}`}
                                                className={
                                                  classes.iconLinkPropNormal
                                                }
                                              >
                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                  }}
                                                  // onClick={() => {
                                                  //   const relative =
                                                  //     relativeList.find(
                                                  //       (c) =>
                                                  //         c.id ===
                                                  //         Number(
                                                  //           firstPolicy.contengentPolicyOwnerId
                                                  //         )
                                                  //     );
                                                  //   if (
                                                  //     relative?.related_customer_id
                                                  //   ) {
                                                  //     navigate(
                                                  //       `/profile/customer/${relative.related_customer_id}`
                                                  //     );
                                                  //   }
                                                  // }}
                                                >
                                                  {relativeMap.get(
                                                    Number(
                                                      firstPolicy.contengentPolicyOwnerId
                                                    )
                                                  ) || ""}
                                                  <FontAwesomeIcon
                                                    icon={faUser}
                                                    style={{ color: "#1976d2" }}
                                                  />
                                                </span>
                                              </Link>
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>

                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                  <Grid container alignItems="left">
                                    {firstPolicy.policyPremium && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Premium
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {formatNumber(
                                                firstPolicy.policyPremium ||
                                                  "0.00"
                                              )}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}

                                    {firstPolicy.policyIssueDate && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Issue Date
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {firstPolicy.policyIssueDate
                                                ? dayjs(
                                                    firstPolicy.policyIssueDate
                                                  ).format("MMM D, YYYY")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.policyPremiumFrequency && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Premium Frequency
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {getPolicyCollectionType(
                                                firstPolicy.policyPremiumFrequency
                                              ) || " "}
                                              {[
                                                "Annually",
                                                "Custom",
                                                "OneTime",
                                              ].includes(
                                                firstPolicy.policyPremiumFrequency
                                              ) &&
                                                (firstPolicy.policyPremiumFrequencyDate
                                                  ? ` - ${dayjs(
                                                      firstPolicy.policyPremiumFrequencyDate
                                                    ).format("MMM D, YYYY")}`
                                                  : "")}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.policyDrawDay && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Draw Day
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {firstPolicy.policyDrawDay || " "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                    {firstPolicy.policyPayor && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                      >
                                        <Grid
                                          container
                                          className={classes.profileDetails}
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            lg={5}
                                            md={4}
                                            sm={4}
                                            xs={4}
                                          >
                                            <Typography
                                              className={classes.text12}
                                            >
                                              Payor
                                              <span style={{ float: "right" }}>
                                                :
                                              </span>
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={7}
                                            md={8}
                                            sm={8}
                                            xs={8}
                                          >
                                            <Typography
                                              className={classes.text123}
                                            >
                                              {firstPolicy.policyPayor || " "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                          {/* <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              sx={{ display: "flex" }}
                            >
                              <Grid item>
                                <Button
                                  variant="contained"
                                  className={classes.addNewButton}
                                  // onClick={() =>
                                  //   navigate(`/customer-deals/${customerId}`)
                                  // }
                                  onClick={() =>
                                    navigate(
                                      `/customer/${customerId}/coverage/${firstPolicy.id}`
                                    )
                                  }
                                >
                                  Add Comments
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  variant="contained"
                                  className={classes.addNewButton}
                                  onClick={() =>
                                    navigate(
                                      `/coverage-report/customer/${customerId}/policy/${policyNumber}`
                                    )
                                  }
                                >
                                  Add Summary Report
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid> */}
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Card
                            className={classes.cardNonRedius}
                            sx={{
                              borderStartEndRadius: "5px",
                              borderStartStartRadius: "5px",
                            }}
                          >
                            <Grid
                              container
                              justifyContent={"space-between"}
                              spacing={2}
                              sx={{ px: 4, py: 2 }}
                              className={classes.activityHistoryHeaderGrid}
                            >
                              <Grid
                                item
                                lg={4}
                                md={4}
                                sm={4}
                                xs={4}
                                pt={2}
                                alignContent={"center"}
                              >
                                <Typography
                                  className={classes.ActivityHistoryHEading}
                                >
                                  Coverage
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                lg={8}
                                md={8}
                                sm={8}
                                xs={8}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Grid
                                  container
                                  spacing={1}
                                  justifyContent="flex-end"
                                  sx={{ display: "flex" }}
                                >
                                  <Grid item>
                                    <Link
                                      to={`/customer/${customerId}/coverage/${firstPolicy.id}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Button
                                        size="small"
                                        // variant="contained"
                                        className={classes.addNewButton}
                                        // onClick={() =>
                                        //   navigate(
                                        //     `/customer/${customerId}/coverage/${firstPolicy.id}`
                                        //   )
                                        // }
                                      >
                                        Add Coverage
                                      </Button>
                                    </Link>
                                  </Grid>
                                  <Grid item>
                                    <Link
                                      to={`/coverage-report/customer/${customerId}/policy/${policyNumber}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Button
                                        size="small"
                                        // variant="contained"
                                        className={classes.addNewButton}
                                        // onClick={() =>
                                        //   navigate(
                                        //     `/coverage-report/customer/${customerId}/policy/${policyNumber}`
                                        //   )
                                        // }
                                      >
                                        Generate Report
                                      </Button>
                                    </Link>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Card>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {/* <Card className={classes.cardNonRedius}> */}
                          {project.map((policy, index) => {
                            let backgroundColor;
                            if (index % 2 === 0) {
                              backgroundColor = "#ffffff";
                            } else if (index % 2 === 1) {
                              backgroundColor = "#ffffff";
                            } else {
                              backgroundColor = "#ffffff";
                            }

                            return (
                              <Grid
                                key={policy.id}
                                container
                                sx={{
                                  backgroundColor: backgroundColor,
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  pt={2}
                                  sx={{
                                    backgroundColor: "#99aabf",
                                    px: 4,
                                    py: "10px",
                                  }}
                                >
                                  <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                  >
                                    <Grid
                                      item
                                      xs
                                      display="flex"
                                      flexDirection="row"
                                      alignItems="center"
                                      gap={2}
                                    >
                                      {policy.coverageOrderNumber != null && (
                                        <Box className={classes.orderNumberBox}>
                                          <Typography
                                            className={
                                              classes.ActivityHistoryHEadingWhite
                                            }
                                          >
                                            {policy.coverageOrderNumber}
                                          </Typography>
                                        </Box>
                                      )}

                                      {/* {policy.policyProductId && (
                                        <Typography
                                          className={
                                            classes.ActivityHistoryHEadingWhite
                                          }
                                        >
                                          {productMap.get(
                                            policy.policyProductId
                                          ) || ""}
                                        </Typography>
                                      )} */}
                                      {policy.policyProductId && (
                                        <Link
                                          to={`/policy-history/${policy.policyProductId}`}
                                          className={classes.iconLinkPropNormal}
                                        >
                                          <Typography
                                            className={
                                              classes.ActivityHistoryHEadingWhite
                                            }
                                          >
                                            <span
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            >
                                              {productMap.get(
                                                policy.policyProductId
                                              ) || ""}
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  paddingLeft: "5px",
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faLink}
                                                  style={{ color: "#1976d2" }}
                                                />
                                              </span>
                                            </span>
                                          </Typography>
                                        </Link>
                                      )}
                                      {policy.policyCoverageAmount && (
                                        <Typography
                                          variant="h4"
                                          className={
                                            classes.contactInfoProfileWhite
                                          }
                                        >
                                          {/* {Number(
                                            policy.policyCoverageAmount ?? 0
                                          ).toFixed(2)} */}
                                          {formatNumber(
                                            policy.policyCoverageAmount ?? 0
                                          )}
                                        </Typography>
                                      )}
                                    </Grid>

                                    {/* <Grid item>
                                        {policy.policyPremiumDetails && (
                                          <Typography
                                            variant="h4"
                                            className={
                                              classes.contactInfoProfile
                                            }
                                          >
                                            $ {policy.policyPremiumDetails}
                                          </Typography>
                                        )}
                                      </Grid> */}

                                    <Grid item>
                                      <Link
                                        to={`/coverage/deal/${policy.id}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Button
                                          variant="contained"
                                          className={
                                            classes.editButtonListProfile
                                          }
                                          onClick={() =>
                                            navigate(
                                              `/coverage/deal/${policy.id}`
                                            )
                                          }
                                        >
                                          <BorderColorRoundedIcon
                                            className={
                                              classes.editListIconProfileAddColor
                                            }
                                          />
                                        </Button>
                                      </Link>
                                    </Grid>

                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        className={
                                          classes.deleteButtonListProfilepage
                                        }
                                        onClick={() =>
                                          handleOpenDeleteProjectPopup(
                                            policy,
                                            "delete"
                                          )
                                        }
                                      >
                                        <DeleteOutlineSharpIcon
                                          className={
                                            classes.editListIconProfileAddColor
                                          }
                                        />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  pt={2}
                                  alignContent={"center"}
                                  sx={{
                                    px: 4,
                                    py: 2,
                                  }}
                                >
                                  <Grid container spacing={1} alignItems="left">
                                    <Grid item lg={8} md={12} sm={12} xs={12}>
                                      <Grid
                                        container
                                        spacing={1}
                                        alignItems="left"
                                      >
                                        {policy.policyPremiumDetails && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                              className={classes.profileDetails}
                                            >
                                              <Grid
                                                item
                                                lg={4}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text2}
                                                >
                                                  Premium Details
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={8}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text23}
                                                >
                                                  {": "}
                                                  {/* {Number(
                                                    policy.policyPremiumDetails ??
                                                      0
                                                  ).toFixed(2)} */}
                                                  {formatNumber(
                                                    policy.policyPremiumDetails ??
                                                      0
                                                  )}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )}
                                        {policy.policyInsuredDetails.length >
                                          0 && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                              className={classes.profileDetails}
                                            >
                                              <Grid
                                                item
                                                lg={4}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text2}
                                                >
                                                  Insured
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={8}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text23}
                                                >
                                                  {": "}

                                                  {policy.policyInsuredDetails.map(
                                                    (insuredId, index) => {
                                                      const customerName =
                                                        relativeMap.get(
                                                          Number(insuredId)
                                                        ) || "";

                                                      return (
                                                        <Link
                                                          to={`/profile/customer/${relatedCustomerIdMap.get(
                                                            Number(insuredId)
                                                          )}`}
                                                          className={
                                                            classes.iconLinkPropNormal
                                                          }
                                                        >
                                                          <span
                                                            key={insuredId}
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() => {
                                                              const relative =
                                                                relativeList.find(
                                                                  (c) =>
                                                                    c.id ===
                                                                    Number(
                                                                      insuredId
                                                                    )
                                                                );
                                                              if (
                                                                relative?.related_customer_id
                                                              ) {
                                                                navigate(
                                                                  `/profile/customer/${relative.related_customer_id}`
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {customerName}
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                display:
                                                                  "inline-flex",
                                                                alignItems:
                                                                  "center",
                                                                paddingLeft:
                                                                  "2px",
                                                                paddingRight:
                                                                  "1px",
                                                              }}
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={faUser}
                                                                style={{
                                                                  color:
                                                                    "#1976d2",
                                                                }}
                                                              />
                                                            </span>
                                                            {index <
                                                              policy
                                                                .policyInsuredDetails
                                                                .length -
                                                                1 && ", "}
                                                          </span>
                                                        </Link>
                                                      );
                                                    }
                                                  )}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )}

                                        {policy.policyPrimaryBenificariesNew
                                          .length > 0 && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                              className={classes.profileDetails}
                                            >
                                              <Grid
                                                item
                                                lg={4}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text2}
                                                >
                                                  Prim Benefi
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={8}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text23}
                                                >
                                                  {": "}

                                                  {policy.policyPrimaryBenificariesNew.map(
                                                    (insuredId, index) => {
                                                      const customerName =
                                                        relativeMap.get(
                                                          Number(
                                                            insuredId.column1
                                                          )
                                                        ) || "";

                                                      return (
                                                        <Link
                                                          to={`/profile/customer/${relatedCustomerIdMap.get(
                                                            Number(
                                                              insuredId.column1
                                                            )
                                                          )}`}
                                                          className={
                                                            classes.iconLinkPropNormal
                                                          }
                                                        >
                                                          <span
                                                            key={index}
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() => {
                                                              const relative =
                                                                relativeList.find(
                                                                  (c) =>
                                                                    c.id ===
                                                                    Number(
                                                                      insuredId
                                                                    )
                                                                );
                                                              if (
                                                                relative?.related_customer_id
                                                              ) {
                                                                navigate(
                                                                  `/profile/customer/${relative.related_customer_id}`
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {customerName}
                                                            {insuredId.payoutPercentage
                                                              ? `- ${insuredId.payoutPercentage}%`
                                                              : ""}
                                                            {insuredId.column2
                                                              ? ` (${insuredId.column2})`
                                                              : ""}
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                display:
                                                                  "inline-flex",
                                                                alignItems:
                                                                  "center",
                                                                paddingLeft:
                                                                  "2px",
                                                                paddingRight:
                                                                  "1px",
                                                              }}
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={faUser}
                                                                style={{
                                                                  color:
                                                                    "#1976d2",
                                                                }}
                                                              />
                                                            </span>
                                                            {index <
                                                              policy
                                                                .policyPrimaryBenificariesNew
                                                                .length -
                                                                1 && ", "}
                                                          </span>
                                                        </Link>
                                                      );
                                                    }
                                                  )}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )}

                                        {policy.policyContengentBenificariesNew
                                          .length > 0 && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                              className={classes.profileDetails}
                                            >
                                              <Grid
                                                item
                                                lg={4}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text2}
                                                >
                                                  Cont Benefi
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={8}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text23}
                                                >
                                                  {": "}

                                                  {policy.policyContengentBenificariesNew.map(
                                                    (insuredId, index) => {
                                                      const customerName =
                                                        relativeMap.get(
                                                          Number(
                                                            insuredId.column1
                                                          )
                                                        ) || "";

                                                      return (
                                                        <Link
                                                          to={`/profile/customer/${relatedCustomerIdMap.get(
                                                            Number(
                                                              insuredId.column1
                                                            )
                                                          )}`}
                                                          className={
                                                            classes.iconLinkPropNormal
                                                          }
                                                        >
                                                          <span
                                                            key={index}
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() => {
                                                              const relative =
                                                                relativeList.find(
                                                                  (c) =>
                                                                    c.id ===
                                                                    Number(
                                                                      insuredId
                                                                    )
                                                                );
                                                              if (
                                                                relative?.related_customer_id
                                                              ) {
                                                                navigate(
                                                                  `/profile/customer/${relative.related_customer_id}`
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            {customerName}
                                                            {insuredId.payoutPercentage
                                                              ? `- ${insuredId.payoutPercentage}%`
                                                              : ""}

                                                            <span
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                display:
                                                                  "inline-flex",
                                                                alignItems:
                                                                  "center",
                                                                paddingLeft:
                                                                  "2px",
                                                                paddingRight:
                                                                  "1px",
                                                              }}
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={faUser}
                                                                style={{
                                                                  color:
                                                                    "#1976d2",
                                                                }}
                                                              />
                                                            </span>
                                                            {index <
                                                              policy
                                                                .policyContengentBenificariesNew
                                                                .length -
                                                                1 && ", "}
                                                          </span>
                                                        </Link>
                                                      );
                                                    }
                                                  )}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Grid item lg={4} md={12} sm={12} xs={12}>
                                      <Grid
                                        container
                                        spacing={1}
                                        alignItems="left"
                                      >
                                        {" "}
                                        {(policy.policyIsLifeTimeExpiryDate ||
                                          policy.policyExpiryDate) && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                              className={classes.profileDetails}
                                            >
                                              <Grid
                                                item
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text2}
                                                >
                                                  Expiry Date
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text23}
                                                >
                                                  {": "}
                                                  {policy.policyIsLifeTimeExpiryDate
                                                    ? "Death"
                                                    : policy.policyExpiryDate
                                                    ? dayjs(
                                                        policy.policyExpiryDate
                                                      ).format("MMM D, YYYY")
                                                    : ""}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )}
                                        {policy.policyCoversionDate && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                              className={classes.profileDetails}
                                            >
                                              <Grid
                                                item
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text2}
                                                >
                                                  Cov. Date
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text23}
                                                >
                                                  {": "}
                                                  {policy.policyCoversionDate
                                                    ? dayjs(
                                                        policy.policyCoversionDate
                                                      ).format("MMM D, YYYY")
                                                    : ""}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )}
                                        {policy.policyRenewalDate && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                              className={classes.profileDetails}
                                            >
                                              <Grid
                                                item
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text2}
                                                >
                                                  Renewal Date
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text23}
                                                >
                                                  {": "}
                                                  {policy.policyRenewalDate
                                                    ? dayjs(
                                                        policy.policyRenewalDate
                                                      ).format("MMM D, YYYY")
                                                    : ""}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )}
                                        {policy.policyPaidUpDate && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                              className={classes.profileDetails}
                                            >
                                              <Grid
                                                item
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text2}
                                                >
                                                  Paid Up Date
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                lg={6}
                                                md={6}
                                                sm={6}
                                                xs={6}
                                              >
                                                <Typography
                                                  className={classes.text23}
                                                >
                                                  {": "}
                                                  {policy.policyPaidUpDate
                                                    ? dayjs(
                                                        policy.policyPaidUpDate
                                                      ).format("MMM D, YYYY")
                                                    : ""}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )}
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        mt: 3,
                                      }}
                                    >
                                      <Grid
                                        container
                                        spacing={1}
                                        justifyContent="flex-end"
                                        sx={{ display: "flex" }}
                                      >
                                        <Grid item>
                                          <Button
                                            size="small"
                                            // variant="contained"
                                            className={classes.addNewButton}
                                            onClick={() =>
                                              handleOpenDialog(policy)
                                            }
                                          >
                                            Comments
                                          </Button>
                                        </Grid>
                                        <Grid item>
                                          <Button
                                            size="small"
                                            // variant="contained"
                                            className={classes.addNewButton}
                                            onClick={() =>
                                              handleOpenDialogSummary(policy)
                                            }
                                          >
                                            Add Additional Comments
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                {/* <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    pt={2}
                                    alignContent={"center"}
                                    sx={{
                                      px: 5,
                                      py: 2,
                                    }}
                                  >
                                    <Grid container alignItems="left">
                                      {policy.policyExpiryDate && (
                                        <Grid
                                          item
                                          lg={6}
                                          md={6}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid
                                            container
                                            className={classes.profileDetails}
                                          >
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Typography variant="subtitle1">
                                                Expiry Date :&nbsp;&nbsp;
                                                {policy.policyExpiryDate
                                                  ? dayjs(
                                                      policy.policyExpiryDate
                                                    ).format("MMM D, YYYY")
                                                  : ""}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Grid> */}
                                {policy.policyTermsArray &&
                                  policy.policyTermsArray.length > 0 && (
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      sx={{
                                        px: 4,
                                        py: 2,
                                      }}
                                    >
                                      <Grid container spacing={2}>
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Box
                                            sx={{
                                              maxHeight: "600px",
                                              minHeight: "auto",
                                              overflow: "auto",
                                              padding: "2px",
                                              "&::-webkit-scrollbar": {
                                                width: "4px",
                                              },
                                              "&::-webkit-scrollbar-track": {
                                                background: "#eeeeee",
                                              },
                                              "&::-webkit-scrollbar-thumb": {
                                                background: "#eeeeee",
                                                borderRadius: "10px",
                                              },
                                              "&::-webkit-scrollbar-thumb:hover":
                                                {
                                                  background: "#eeeeee",
                                                },
                                            }}
                                          >
                                            <Grid
                                              container
                                              alignItems="center"
                                              className={
                                                classes.titleSummaryReportBox
                                              }
                                            >
                                              <Grid
                                                container
                                                spacing={1}
                                                alignItems="center"
                                                padding={1}
                                              >
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  display="flex"
                                                  justifyContent="flex-start"
                                                  alignItems="end"
                                                >
                                                  <Typography variant="subtitle1">
                                                    Additional Comments
                                                  </Typography>
                                                </Grid>
                                                {policy.policyTermsArray &&
                                                policy.policyTermsArray.length >
                                                  0 ? (
                                                  policy.policyTermsArray.map(
                                                    (
                                                      item: policyAllPrintTermsArray,
                                                      idx: number
                                                    ) => (
                                                      <Grid
                                                        item
                                                        lg={12}
                                                        md={12}
                                                        sm={12}
                                                        xs={12}
                                                        key={idx}
                                                      >
                                                        <Grid
                                                          container
                                                          spacing={2}
                                                          alignItems="center"
                                                        >
                                                          {/* <Grid
                                                              item
                                                              lg={0.5}
                                                              md={1}
                                                              sm={1}
                                                              xs={1}
                                                              display="flex"
                                                              justifyContent="flex-start"
                                                              alignItems="flex-start"
                                                            >
                                                              <Typography
                                                                sx={{
                                                                  fontSize: 13,
                                                                  display:
                                                                    "flex",
                                                                  justifyContent:
                                                                    "center",
                                                                  alignItems:
                                                                    "center",
                                                                  width: 18,
                                                                  height: 18,
                                                                  borderRadius:
                                                                    "50%",
                                                                  border:
                                                                    "1px solid ",
                                                                  textAlign:
                                                                    "center",
                                                                  lineHeight:
                                                                    "13px",
                                                                }}
                                                              >
                                                                {"✔"}
                                                              </Typography>
                                                            </Grid> */}
                                                          <Grid
                                                            item
                                                            lg={0.5}
                                                            md={1}
                                                            sm={2}
                                                            xs={2}
                                                            display="flex"
                                                            justifyContent="flex-start"
                                                            alignItems="flex-start"
                                                          >
                                                            {item.isReport ? (
                                                              <CheckCircleRoundedIcon
                                                                sx={{
                                                                  fontSize: 22,
                                                                  color:
                                                                    "#06b57d",
                                                                }}
                                                              />
                                                            ) : (
                                                              <CancelIcon
                                                                color="error"
                                                                sx={{
                                                                  fontSize: 22,
                                                                }}
                                                              />
                                                            )}
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            lg={11.5}
                                                            md={11}
                                                            sm={10}
                                                            xs={10}
                                                          >
                                                            <Typography
                                                              className={
                                                                classes.bodyPrint133
                                                              }
                                                              component="div"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  item.policyTermsDescription,
                                                              }}
                                                            />
                                                            {/* <Typography
                                                              className="headingSummary"
                                                              sx={{
                                                                pb: "2px",
                                                              }}
                                                            >
                                                              {
                                                                item.policyTermsDescription
                                                              }
                                                            </Typography> */}
                                                          </Grid>
                                                        </Grid>
                                                      </Grid>
                                                    )
                                                  )
                                                ) : (
                                                  <Typography
                                                    className="noData"
                                                    sx={{
                                                      textAlign: "center",
                                                      color: "gray",
                                                    }}
                                                  ></Typography>
                                                )}
                                              </Grid>
                                            </Grid>
                                          </Box>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )}
                                {policy.policySummaryReportArray &&
                                  policy.policySummaryReportArray.length >
                                    0 && (
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      sx={{
                                        px: 4,
                                        py: 2,
                                      }}
                                    >
                                      <Grid container spacing={2}>
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Box
                                            sx={{
                                              maxHeight: "600px",
                                              minHeight: "auto",
                                              overflow: "auto",
                                              padding: "2px",
                                              "&::-webkit-scrollbar": {
                                                width: "4px",
                                              },
                                              "&::-webkit-scrollbar-track": {
                                                background: "#eeeeee",
                                              },
                                              "&::-webkit-scrollbar-thumb": {
                                                background: "#eeeeee",
                                                borderRadius: "10px",
                                              },
                                              "&::-webkit-scrollbar-thumb:hover":
                                                {
                                                  background: "#eeeeee",
                                                },
                                            }}
                                          >
                                            <Grid
                                              container
                                              alignItems="center"
                                              className={
                                                classes.titleSummaryReportBox
                                              }
                                            >
                                              <Grid
                                                container
                                                spacing={1}
                                                alignItems="center"
                                                padding={1}
                                              >
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  display="flex"
                                                  justifyContent="flex-start"
                                                  alignItems="end"
                                                >
                                                  <Typography
                                                    // className={classes.contactInfoViewPage}
                                                    variant="subtitle1"
                                                  >
                                                    Summary Report
                                                  </Typography>
                                                </Grid>
                                                {Array.isArray(
                                                  policy.policySummaryReportArray
                                                ) &&
                                                policy.policySummaryReportArray
                                                  .length > 0 ? (
                                                  policy.policySummaryReportArray.map(
                                                    (
                                                      item: policyTermsArray,
                                                      idx: number
                                                    ) => (
                                                      <Grid
                                                        item
                                                        lg={12}
                                                        md={12}
                                                        sm={12}
                                                        xs={12}
                                                        key={idx}
                                                      >
                                                        <Grid
                                                          container
                                                          spacing={2}
                                                          alignItems="center"
                                                        >
                                                          {/* <Grid
                                                              item
                                                              lg={0.5}
                                                              md={0.5}
                                                              sm={0.5}
                                                              xs={0.5}
                                                              display="flex"
                                                              justifyContent="flex-start"
                                                              alignItems="flex-start"
                                                            >
                                                              <Typography
                                                                sx={{
                                                                  fontSize: 13,
                                                                  display:
                                                                    "flex",
                                                                  justifyContent:
                                                                    "center",
                                                                  alignItems:
                                                                    "center",
                                                                  width: 18,
                                                                  height: 18,
                                                                  borderRadius:
                                                                    "50%",
                                                                  border:
                                                                    "1px solid ",
                                                                  textAlign:
                                                                    "center",
                                                                  lineHeight:
                                                                    "13px",
                                                                }}
                                                              >
                                                                {"✔"}
                                                              </Typography>
                                                            </Grid> */}
                                                          <Grid
                                                            item
                                                            lg={0.5}
                                                            md={2}
                                                            sm={2}
                                                            xs={2}
                                                            display="flex"
                                                            justifyContent="flex-start"
                                                            alignItems="flex-start"
                                                          >
                                                            {item.isPolicyTermsSummaryReport ? (
                                                              <CheckCircleRoundedIcon
                                                                sx={{
                                                                  fontSize: 22,
                                                                  color:
                                                                    "#cad00c",
                                                                }}
                                                              />
                                                            ) : (
                                                              <CancelIcon
                                                                color="error"
                                                                sx={{
                                                                  fontSize: 22,
                                                                }}
                                                              />
                                                            )}
                                                          </Grid>
                                                          <Grid
                                                            item
                                                            lg={11.5}
                                                            md={10}
                                                            sm={10}
                                                            xs={10}
                                                          >
                                                            <Typography
                                                              className="headingSummary"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  item.policyTermsDescription,
                                                              }}
                                                            />
                                                            {/* <Typography
                                                              className="headingSummary"
                                                              sx={{
                                                                pb: "2px",
                                                              }}
                                                            >
                                                              {
                                                                item.policyTermsDescription
                                                              }
                                                            </Typography> */}
                                                          </Grid>
                                                        </Grid>
                                                      </Grid>
                                                    )
                                                  )
                                                ) : (
                                                  <Typography
                                                    className="noData"
                                                    sx={{
                                                      textAlign: "center",
                                                      color: "gray",
                                                    }}
                                                  ></Typography>
                                                )}
                                              </Grid>
                                            </Grid>
                                          </Box>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )}

                                <Grid
                                  item
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  sx={{
                                    backgroundColor: "#f4fafe",
                                    pt: 3,
                                  }}
                                ></Grid>

                                <>
                                  {projectToDelete && (
                                    <DeletePopup
                                      open={openDeleteProject}
                                      handleCloseDelete={
                                        handleCloseDeleteProjectPopup
                                      }
                                      onConfirm={async () => {
                                        await handleDelete(
                                          projectToDelete.id.toString()
                                        );
                                      }}
                                      title="Delete Coverage"
                                      content={`Are you sure you want to delete ${
                                        projectToDelete.policyNumber
                                      }${
                                        productMap.get(
                                          projectToDelete.policyProductId
                                        )
                                          ? ` - ${productMap.get(
                                              projectToDelete.policyProductId
                                            )}`
                                          : ""
                                      }?`}
                                    />
                                  )}
                                </>
                              </Grid>
                            );
                          })}
                          {/* </Card> */}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </>
          </Grid>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={8} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid container>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.profileBottomSetUp23New}
                  >
                    {/* <Grid className={classes.profileBottomDwonNew}>
                      <Typography className={classes.profileDetailItemList2}>
                        Policy Full Coverage Details :{" "}
                        {firstPolicy.policyNumber}
                      </Typography>
                    </Grid> */}

                    <Grid className={classes.profileBottomDwonNew}>
                      <Typography
                        // variant="h4"
                        className={classes.profileDetailItemList2}
                      >
                        Policy Full Coverage Details
                      </Typography>
                    </Grid>
                    <Grid className={classes.profileBottomDwonNew}>
                      <Typography
                        // variant="h3"
                        className={classes.profileDetailItemList2}
                      >
                        {firstPolicy.policyNumber}
                      </Typography>
                    </Grid>
                    <Grid
                      className={classes.buttonGroupList}
                      onClick={() =>
                        navigate(`/profile/customer/${customer?.id}`)
                      }
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      <Link
                        to={`/profile/customer/${customer?.id}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Typography
                          variant="h4"
                          className={classes.profileDetailItemList}
                          sx={{ pt: 2 }}
                        >
                          {toProperCase(customer.customerFirstName || "") +
                            " " +
                            toProperCase(customer.customerLastName || "")}
                        </Typography>
                      </Link>
                      {customer.customerRefId && (
                        <Typography
                          variant="subtitle1"
                          sx={{ px: "3px", pt: 2 }}
                        >
                          <span className={classes.customerDetails}>
                            {` (${customer.customerRefId})`}
                          </span>{" "}
                        </Typography>
                      )}
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      className={classes.buttonGroupList}
                    >
                      {customer.customerMobileNum && (
                        <Grid item>
                          <Typography
                            // variant="body1"
                            className={classes.contactInfoProfile}
                          >
                            {customer.customerMobileNum && (
                              <span className={classes.iconText}>
                                {formatPhoneNumberForDisplaySpace(
                                  customer.customerMobileNum
                                )}
                              </span>
                            )}
                          </Typography>
                        </Grid>
                      )}
                      {customer.customerEmail && (
                        <Grid item>
                          <Typography
                            // variant="body1"
                            className={classes.contactInfoProfile}
                          >
                            {customer.customerEmail && (
                              <span className={classes.iconText}>
                                {customer.customerEmail?.toLowerCase()}
                              </span>
                            )}
                          </Typography>
                        </Grid>
                      )}
                      {!customer.customerEmail &&
                        !customer.customerMobileNum && (
                          <Grid item pt={2}>
                            <Typography
                              className={classes.contactInfoProfileWhiterr}
                            >
                              {""}
                            </Typography>
                          </Grid>
                        )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              {renderContent()}
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={4} md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            {historyRecords.length > 0 && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 3, padding: 2 }}
                    className={classes.activityHistoryHeaderGrid}
                  >
                    <Grid
                      item
                      pt={2}
                      sx={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Typography className={classes.cardTitle}>
                        History
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12} p={2}>
                    <Box
                      sx={{
                        // minHeight: "60vh",
                        maxHeight: "100vh",
                        overflow: "auto",
                        padding: "2px",
                        "&::-webkit-scrollbar": {
                          width: "4px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#eeeeee",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#eeeeee",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#eeeeee",
                        },
                      }}
                    >
                      <Stack spacing={2}>
                        {historyRecords.map((order, index) => {
                          const statusName = order.updated_by
                            ? "Updated"
                            : "Created";

                          const statusNameIcon = order.updated_by
                            ? "ChangedStatusOrange"
                            : "ChangedStatusGreen";

                          const userName = userMap.get(order.created_by) || "";
                          return (
                            <Card
                              key={order.id}
                              variant="outlined"
                              className={classes.orderListRightCard2}
                            >
                              <CardContent>
                                <Stack
                                  spacing={1}
                                  mb={1}
                                  onClick={() => toggleExpandHis(order.id)}
                                  sx={{ cursor: "pointer" }}
                                >
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    sx={{ mb: 1 }}
                                  >
                                    <Typography variant="h6" fontWeight={600}>
                                      {dayjs(order.created_at).format(
                                        "MMM D, YYYY h:mm A"
                                      )}
                                    </Typography>

                                    <ExpandMore
                                      expand={
                                        expandedTemplateIdHis === order.id
                                      }
                                      onClick={() => toggleExpandHis(order.id)}
                                      aria-expanded={
                                        expandedTemplateIdHis === order.id
                                      }
                                    >
                                      <ExpandMoreIcon />
                                    </ExpandMore>
                                  </Stack>

                                  <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={1}
                                    flexWrap="wrap"
                                  >
                                    <Typography
                                      variant="body2"
                                      className={
                                        classes.orderLsitHeadingTypoColor
                                      }
                                    >
                                      {order.policyNumber}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      className={
                                        classes.orderLsitHeadingTypoColor
                                      }
                                    >
                                      {`| ${
                                        productMap.get(
                                          Number(order.policyProductId)
                                        ) || ""
                                      }`}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      className={
                                        classes.orderLsitHeadingTypoColor
                                      }
                                    >
                                      {`| ${
                                        brandMap.get(
                                          Number(order.policyInsuranceCompanyId)
                                        ) || ""
                                      }`}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      className={
                                        classes.orderLsitHeadingTypoColor
                                      }
                                    >
                                      {` | ${userName}`}
                                    </Typography>
                                  </Stack>
                                  <>
                                    <Stack spacing={1} mb={1}>
                                      <Stack
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        spacing={1}
                                        flexWrap="wrap"
                                      >
                                        {
                                          statusIcon[
                                            statusNameIcon as keyof typeof statusIcon
                                          ]
                                        }

                                        <Typography
                                          fontWeight={600}
                                          sx={{
                                            color:
                                              statusName === "Created"
                                                ? "green"
                                                : "orange",
                                          }}
                                        >
                                          <strong>{statusName}</strong>
                                        </Typography>
                                      </Stack>
                                    </Stack>
                                  </>
                                </Stack>
                                <Stack spacing={1} mb={1}>
                                  {order.coveragerecord_history.length > 0 ? (
                                    <Collapse
                                      in={expandedTemplateIdHis === order.id}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <Divider sx={{ mb: 2 }} />
                                      {/* Render 0th index as Created */}
                                      {(() => {
                                        const msg =
                                          order.coveragerecord_history[0];
                                        const createdFields = getCreatedFields(
                                          msg,
                                          {
                                            brandMap,
                                            relativeMap,
                                            productMap,
                                            typofCoverageMap,
                                            relatedCustomerIdMap,
                                          }
                                        );

                                        return (
                                          <Box key={msg.id} pb={4}>
                                            <Stack
                                              direction="row"
                                              alignItems="center"
                                              justifyContent="space-between"
                                              sx={{ mb: 1 }}
                                            >
                                              <Typography
                                                color="primary"
                                                style={{ fontWeight: 600 }}
                                              >
                                                <Box
                                                  display="flex"
                                                  alignItems="center"
                                                  gap={1}
                                                >
                                                  <PublishedWithChangesIcon
                                                    fontSize="medium"
                                                    color="primary"
                                                    style={{
                                                      fontSize: 20,
                                                      fontWeight: 600,
                                                    }}
                                                  />
                                                  {userMap.get(
                                                    msg.created_by
                                                  ) || ""}{" "}
                                                  created record:
                                                </Box>
                                              </Typography>

                                              <Typography variant="h6">
                                                {dayjs(msg.created_at).format(
                                                  "MMM D, YYYY h:mm A"
                                                )}
                                              </Typography>
                                            </Stack>

                                            {createdFields.map((item, idx) => (
                                              <Box key={idx} mb={2} ml={4}>
                                                <Stack
                                                  direction="row"
                                                  alignItems="center"
                                                  spacing={1}
                                                >
                                                  {statusIcon["Created"]}
                                                  <Typography variant="body2">
                                                    {variantPropName(
                                                      item.field
                                                    )}{" "}
                                                    added ➜ {item.value}
                                                  </Typography>
                                                </Stack>
                                              </Box>
                                            ))}
                                          </Box>
                                        );
                                      })()}

                                      {order.coveragerecord_history
                                        .slice(1)
                                        .map((msg, index) => {
                                          const prev =
                                            order.coveragerecord_history[index];
                                          const changes =
                                            msg.status === "updated"
                                              ? getChangedFields(msg, prev, {
                                                  brandMap,
                                                  relativeMap,
                                                  productMap,
                                                  typofCoverageMap,
                                                  relatedCustomerIdMap,
                                                })
                                              : getChangedFields(msg, prev, {
                                                  brandMap,
                                                  relativeMap,
                                                  productMap,
                                                  typofCoverageMap,
                                                  relatedCustomerIdMap,
                                                });

                                          return (
                                            <Box key={msg.id} pb={4}>
                                              {changes &&
                                                changes.length > 0 && (
                                                  <>
                                                    <Stack
                                                      direction="row"
                                                      alignItems="center"
                                                      justifyContent="space-between"
                                                      sx={{ mb: 1 }}
                                                    >
                                                      <Typography
                                                        color="primary"
                                                        style={{
                                                          fontWeight: 600,
                                                        }}
                                                      >
                                                        <Box
                                                          display="flex"
                                                          alignItems="center"
                                                          gap={1}
                                                        >
                                                          <PublishedWithChangesIcon
                                                            fontSize="medium"
                                                            color="primary"
                                                            style={{
                                                              fontSize: 20,
                                                              fontWeight: 600,
                                                            }}
                                                          />
                                                          {userMap.get(
                                                            msg.created_by
                                                          ) || ""}{" "}
                                                          made changes:
                                                        </Box>
                                                      </Typography>

                                                      <Typography variant="h6">
                                                        {dayjs(
                                                          msg.created_at
                                                        ).format(
                                                          "MMM D, YYYY h:mm A"
                                                        )}
                                                      </Typography>
                                                    </Stack>

                                                    {changes.map(
                                                      (change, idx) => {
                                                        const statusType =
                                                          getStatusType(
                                                            change.oldValue,
                                                            change.newValue
                                                          );

                                                        return (
                                                          <Box
                                                            key={idx}
                                                            mb={2}
                                                            ml={4}
                                                          >
                                                            {change.field ===
                                                              "policyRemark" ||
                                                            change.field ===
                                                              "policyOfficeUse" ||
                                                              change.field ===
                                                              "policySummaryReportArray" ? (
                                                              <Stack
                                                                direction="row"
                                                                alignItems="center"
                                                                spacing={1}
                                                              >
                                                                {statusType &&
                                                                  statusIcon[
                                                                    statusType
                                                                  ]}
                                                                <Typography variant="body2">
                                                                  {variantPropName(
                                                                    change.field
                                                                  )}{" "}
                                                                  {statusType ===
                                                                    "Created" && (
                                                                    <>added ➜</>
                                                                  )}
                                                                  {statusType ===
                                                                    "Modified" && (
                                                                    <>
                                                                      changed
                                                                      from{" "}
                                                                      <s
                                                                        dangerouslySetInnerHTML={{
                                                                          __html: Array.isArray(change.oldValue)
                                                                            ? change.oldValue.join(", ")
                                                                            : change.oldValue,
                                                                        }}
                                                                      />{" "}
                                                                      ➜
                                                                    </>
                                                                  )}
                                                                  {statusType ===
                                                                    "Deleted" && (
                                                                    <>
                                                                      removed
                                                                      (was{" "}
                                                                    </>
                                                                  )}
                                                                </Typography>

                                                                <Typography
                                                                  variant="body2"
                                                                  dangerouslySetInnerHTML={{
                                                                    __html: Array.isArray(change.newValue)
                                                                      ? change.newValue.join(", ")
                                                                      : change.newValue,
                                                                  }}
                                                                />
                                                              </Stack>
                                                            ) : (
                                                              <Stack
                                                                direction="row"
                                                                alignItems="center"
                                                                spacing={1}
                                                              >
                                                                {statusType &&
                                                                  statusIcon[
                                                                    statusType
                                                                  ]}
                                                                <Typography variant="body2">
                                                                  {variantPropName(
                                                                    change.field
                                                                  )}{" "}
                                                                  {statusType ===
                                                                    "Created" && (
                                                                    <>
                                                                      added ➜{" "}
                                                                      {
                                                                        change.newValue
                                                                      }
                                                                    </>
                                                                  )}
                                                                  {statusType ===
                                                                    "Modified" && (
                                                                    <>
                                                                      changed
                                                                      from{" "}
                                                                      <s>
                                                                        {
                                                                          change.oldValue
                                                                        }
                                                                      </s>{" "}
                                                                      ➜{" "}
                                                                      {
                                                                        change.newValue
                                                                      }
                                                                    </>
                                                                  )}
                                                                  {statusType ===
                                                                    "Deleted" && (
                                                                    <>
                                                                      removed
                                                                      (was{" "}
                                                                      {
                                                                        change.oldValue
                                                                      }
                                                                      )
                                                                    </>
                                                                  )}
                                                                </Typography>
                                                              </Stack>
                                                            )}
                                                          </Box>
                                                        );
                                                      }
                                                    )}
                                                  </>
                                                )}
                                            </Box>
                                          );
                                        })}
                                    </Collapse>
                                  ) : (
                                    <Grid item xs={12}>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        No history available
                                      </Typography>
                                    </Grid>
                                  )}
                                </Stack>
                              </CardContent>
                            </Card>
                          );
                        })}
                      </Stack>
                    </Box>
                  </Grid>
                </Card>
              </Grid>
            )}
          </Grid>
        </Grid>
        {selectedProduct && (
          <NewTermsConditionReport
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedProduct}
          />
        )}

        {selectedProductSummary && (
          <NewSummaryReport
            openModel={openDialogSummary}
            handleCloseDialog={handleCloseDialogSummary}
            data={selectedProductSummary}
          />
        )}

        {selectedProductOffice && (
          <NewOfficeUse
            openModel={openDialogOffice}
            handleCloseDialog={handleCloseDialogOffice}
            data={selectedProductOffice}
          />
        )}
      </Grid>
    </div>
  );
};

export default Index;
